import types from './types';

const INITIAL_STATE = {
    user: null,
    exports: [],
    loading: true,
    exportsPage: 1,
    hasMoreExports: true
};

const userInfoReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case types.SET_USER:
            return {
                ...state,
                user: action.payload
            };
        case types.SET_EXPORTS:
            return {
                ...state,
                exports: action.payload
            };
        case types.SET_LOADING:
            return {
                ...state,
                loading: action.payload
            };
        case types.SET_CREDITS:
            if (!state.user) return state;
            return {
                ...state,
                user: { ...state.user, renderCredits: action.payload }
            };
        case types.SET_SETTINGS:
            if (!state.user) return state;
            return {
                ...state,
                user: { ...state.user, ...action.payload }
            };
        case types.RESET_USER_INFO:
            return INITIAL_STATE;
        case types.APPEND_EXPORTS:
            return {
                ...state,
                exports: [...state.exports, ...action.payload],
                exportsPage: state.exportsPage + 1,
                hasMoreExports: action.payload.length > 0
            };
        case types.REMOVE_EXPORT:
            return {
                ...state,
                exports: state.exports.filter(exp => exp.exportId !== action.payload)
            };
        default:
            return state;
    }
};

export default userInfoReducer;
